import { compose, partial } from 'underscore';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';

import {
    selectDay,
    toggleFilterAction,
    selectFilterCategoryAction,
    toggleTag,
    clearCategoryTags,
    clearLocationsTags,
    updateTime,
    selectTime,
    clearTime,
    clearAllTags,
    clientNavigationAction,
    toggleMarker,
    fetchAgenda,
    fetchPartOfSession,
    searchAgendaSessions,
    changeActiveTab,
    getSessionsByIds,
    changeViewMode,
    getSliderSessions,
    setScrollToSessionBroadcastAction,
    fetchSpeakers,
    fetchMarkers,
    fetchSessionRegData,
} from '../../../actions/AgendaActions';
import { fetchSponsorsByEvent } from '../../../actions/SponsorActions';
import {
    getUserTicketsByEvent,
    toggleSessionRegistrationStatusPerSession,
    openCloseTicketSelectionPopUp,
    selectTicketByUserAction,
    setSessionFullRegistration,
} from '../../../actions/UserProfileActions';
import { setVirtualSessionDetails, setRecordUrl } from '../../../actions/SessionActions';
import {
    settingsSelector,
    sessionsByDaySelector,
    agendaDaysSelector,
    agendaFilterSelector,
    selectedDaysSelector,
    selectedTagsSelector,
    speakersSelector,
    hasSessionsSelector,
    shouldFetchAgendaSelector,
    shouldShowSessionPreviewWindowSelector,
    shouldStickAgendaSearchSelector,
    shouldShowSessionDescriptionAgenda,
    sessionsToRenderSelector,
    sessionsMapSelector,
    ticketsSelectionDataSelector,
    shouldFetchSpeakersSelector,
} from '../../../selectors/AgendaSelectors';
import { searchBySpeaker } from '../../../actions/SpeakerActions';
import {
    showEmailLogin,
    hideEmailLogin,
    setLoginV2SpinnerOrigin,
    setLoginV2OffsetTop,
} from '../../../actions/LoginActions';
import {
    eventSelector,
    getInternalAgendaUrl,
    getPublicWebsiteBaseUrlSelector,
} from '../../../selectors/EventSelectors';
import { eventUrlsSelector } from '../../../selectors/EventSelectors';
import {
    isLoginShownSelector,
    loginLoadingStateSelector,
    enableLoginRegistrationPopUpSelector,
} from '../../../selectors/LoginSelectors';
import { isRingAvailableSelector } from '../../../selectors/RingSelectors';

import AgendaView from './AgendaView';

const mapStateToProps = (state) => {
    const { meReducer: { me }, siteConfReducer: { siteConf } } = state;
    const event = eventSelector(state);
    return {
        me,
        event,
        isLoading: state.agendaReducer.isLoading,
        eventUrls: eventUrlsSelector(state),
        settings: settingsSelector(state),
        speakers: speakersSelector(state),
        sessions: sessionsByDaySelector(state),
        selectedDays: selectedDaysSelector(state),
        agendaDays: agendaDaysSelector(state),
        filter: agendaFilterSelector(state),
        selectedTags: selectedTagsSelector(state),
        hasSessions: hasSessionsSelector(state),
        shouldFetchAgenda: shouldFetchAgendaSelector(state),
        shouldFetchSpeakers: shouldFetchSpeakersSelector(state),
        agendaUrl: getInternalAgendaUrl(state),
        isSessionRegistrationEnabled: state.agendaReducer.isSessionRegistrationEnabled,
        siteConf,
        isEmailLoginShown: isLoginShownSelector(state),
        loginV2LoadingState: loginLoadingStateSelector(state),
        activeTab: state.agendaReducer.activeTab,
        viewMode: state.agendaReducer.viewMode,
        shouldShowSessionPreviewWindow: shouldShowSessionPreviewWindowSelector(state),
        shouldStickAgendaSearch: shouldStickAgendaSearchSelector(state),
        shouldShowSessionDescriptionAgenda: shouldShowSessionDescriptionAgenda(state),
        sessionsMap: sessionsMapSelector(state),
        sessionsToRender: sessionsToRenderSelector(state),
        ticketsSelectionData: ticketsSelectionDataSelector(state),
        publicWebsiteBaseUrl: getPublicWebsiteBaseUrlSelector(state),
        enableLoginRegistrationPopUp: enableLoginRegistrationPopUpSelector(state),
        isRingAvailable: isRingAvailableSelector(state),
    };
};

const updateURLQueryParams = (router, location, queryObject) => {
    const query = { ...queryObject, count: null, offset: null };
    delete query.count;
    delete query.offset;
    delete query.sessionsIds;
    router.push({
        pathname: location.pathname,
        query
    });
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const { router, location } = ownProps;
    const updateURLQueryParamsByQuery = partial(updateURLQueryParams, router, location);

    return bindActionCreators({
        selectDay: partial(selectDay, updateURLQueryParamsByQuery),
        toggleFilter: toggleFilterAction,
        selectFilterCategory: selectFilterCategoryAction,
        toggleTag: partial(toggleTag, updateURLQueryParamsByQuery),
        clearCategoryTags: partial(clearCategoryTags, updateURLQueryParamsByQuery),
        clearLocationsTags: partial(clearLocationsTags, updateURLQueryParamsByQuery),
        selectTime: partial(selectTime, updateURLQueryParamsByQuery),
        updateTime,
        clearTime: partial(clearTime, updateURLQueryParamsByQuery),
        clearAllTags: partial(clearAllTags, updateURLQueryParamsByQuery),
        clientNavigationAction,
        toggleMarker,
        fetchAgenda,
        fetchSpeakers,
        fetchMarkers,
        fetchSessionRegData,
        fetchPartOfSession,
        searchAgendaSessions,
        searchBySpeaker,
        showEmailLogin,
        changeActiveTab,
        getSessionsByIds,
        changeViewMode,
        fetchSponsorsByEvent,
        getSliderSessions,
        getUserTicketsByEvent,
        toggleSessionRegistrationStatusPerSession,
        openCloseTicketSelectionPopUp,
        selectTicketByUserAction,
        setSessionFullRegistration,
        setVirtualSessionDetails,
        hideEmailLogin,
        setScrollToSessionBroadcastAction,
        setRecordUrl,
        setLoginV2OffsetTop,
        setLoginV2SpinnerOrigin,
    }, dispatch);
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
)(AgendaView);
